import { useState } from 'react';


const morseCodeMap = {
  'A': '.-', 'B': '-...', 'C': '-.-.', 'D': '-..', 'E': '.', 'F': '..-.', 
  'G': '--.', 'H': '....', 'I': '..', 'J': '.---', 'K': '-.-', 'L': '.-..', 
  'M': '--', 'N': '-.', 'O': '---', 'P': '.--.', 'Q': '--.-', 'R': '.-.', 
  'S': '...', 'T': '-', 'U': '..-', 'V': '...-', 'W': '.--', 'X': '-..-', 
  'Y': '-.--', 'Z': '--..', '1': '.----', '2': '..---', '3': '...--', 
  '4': '....-', '5': '.....', '6': '-....', '7': '--...', '8': '---..', 
  '9': '----.', '0': '-----', ' ': '/'
};

const morseCodeMapReverse = Object.fromEntries(Object.entries(morseCodeMap).map(([key, value]) => [value, key]));

const MorseCodeTranslators = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [isEnglishToMorse, setIsEnglishToMorse] = useState(true);


  const handleInputChange = (event) => {
    const text = event.target.value.toUpperCase();
    setInput(text);
    if (isEnglishToMorse) {
      setOutput(text.split('').map(char => morseCodeMap[char] || '').join(' '));
    } else {
      setOutput(text.split(' ').map(char => morseCodeMapReverse[char] || '').join(''));
    }
  };

  const handleSwitchChange = () => {
    setIsEnglishToMorse(!isEnglishToMorse);
    if (!isEnglishToMorse) {
      setOutput(input.split('').map(char => morseCodeMap[char] || '').join(' '));
    } else {
      setOutput(input.split(' ').map(char => morseCodeMapReverse[char] || '').join(''));
    }
  };

    const [copyButtonLabel, setCopyButtonLabel] = useState('Copy '); // State for button label
  
  // Clear input fields
  const clearFields = () => {
    setInput('');
    setOutput('');

  };


  const handleCopyClick = () => {
    navigator.clipboard.writeText(output);
    setCopyButtonLabel('Copied!'); // Update button label to "Copied!"
    setTimeout(() => setCopyButtonLabel('Copy'), 1500); // Revert back to "Copy Number" after 1.5 seconds
  };


     // Function to calculate text statistics
     const calculateTextStats = (text) => {
      const totalCharacters = text.length;
      const totalCharactersWithoutSpace = text.replace(/\s+/g, '').length;
      const totalWords = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
      const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
      const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;
  
      return {
        totalCharacters,
        totalCharactersWithoutSpace,
        totalWords,
        totalParagraphs,
        totalSentences,
      };
    };

    
      // Calculate stats dynamically based on current binary value
  const stats = calculateTextStats(input);

  return (
    <div className="container mt-5 p-4 bg-white rounded shadow">
    <div className="card-body">
      
      <div className="d-flex justify-content-center mb-4">
        <button 
          className={`btn ${isEnglishToMorse ? 'btn-primary' : 'btn-light'} me-2`}
          onClick={() => setIsEnglishToMorse(true)}
        >
         English to Morse
        </button>
        <button 
          className={`btn ${!isEnglishToMorse ? 'btn-primary' : 'btn-light'}`}
          onClick={() => setIsEnglishToMorse(false)}
        >
          Morse to English
        </button>
      </div>
      <textarea 
        className="form-control mb-4" 
        rows={5} 
        value={input} 
        onChange={handleInputChange} 
        placeholder={isEnglishToMorse ? 'Enter English text' : 'Enter Morse code'}
      />
           <h2 className="h5"> Output:</h2>

      <div className="d-flex justify-content-between align-items-center mb-4">

     <textarea
        className="form-control mb-4"
        style={{ height: '10rem' }}
        value={output}
        readOnly
        rows={10}
      />

      </div>
        <button 
          className="btn btn-primary" 
          onClick={handleCopyClick}
        >
         {copyButtonLabel}

        </button>
        <button className="btn btn-danger" onClick={clearFields}>
            Clear
          </button>
  
      </div>
   

      <div className="mt-3 text-muted">
            <p>
              Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}</p>
            <p>
               Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
            </p>
          </div>
  
</div>

  );
};

export default MorseCodeTranslators;
